import { useState } from 'react';
import './RealisationsSection.css';

const images = [
    '/images/OmTravaux/Cuisine1.jpg',
    '/images/OmTravaux/Iso4.jpg',
    '/images/OmTravaux/Iso3.jpg',
    '/images/OmTravaux/Iso1.jpg',
    '/images/OmTravaux/Cuisine3.jpg',
    '/images/OmTravaux/Sdb5.jpg',
    '/images/OmTravaux/Iso6.jpg',
    // '/images/OmTravaux/Sdb4.jpg',
    // '/images/OmTravaux/Sdb1.jpg',
    // '/images/OmTravaux/Iso2.jpg',
    // '/images/OmTravaux/Cuisine2.jpg',
    // '/images/OmTravaux/Sdb3.jpg',
];

export default function RealisationsSection() {
    const [selectedImage, setSelectedImage] = useState(null);

    const handleClick = (src) => {
        if (window.innerWidth > 768) {
            setSelectedImage(src);
        }
    };

    return (
        <section className="realisations-section" id="realisations">
            <div className="realisations-wrapper">
                <div className="realisations-heading">
                    <p className="realisations-badge">Nos réalisations</p>

                    <h2 className="realisations-title">
                        Des chantiers pensés avec soin,
                        <span> réalisés avec exigence</span>
                    </h2>

                    <p className="realisations-subtext">
                        Découvrez un aperçu de projets de rénovation intérieure et extérieur réalisés
                        avec sérieux, précision et sens du détail. Chaque réalisation
                        reflète notre volonté de livrer des espaces plus modernes,
                        harmonieux et durables.
                    </p>
                </div>

                <div className="realisations-grid">
                    {images.map((src, index) => (
                        <div
                            key={index}
                            className={`real-card ${index === 0 || index === 5 ? 'real-card-large' : ''}`}
                            onClick={() => handleClick(src)}
                        >
                            <img
                                src={src}
                                alt={`Réalisation ${index + 1}`}
                                className="real-img"
                            />
                            <div className="real-card-overlay">
                                {/* <span>Voir le projet</span> */}
                            </div>
                        </div>
                    ))}
                </div>

                {selectedImage && (
                    <div className="lightbox" onClick={() => setSelectedImage(null)}>
                        <button
                            className="lightbox-close"
                            onClick={() => setSelectedImage(null)}
                            aria-label="Fermer l’image"
                            type="button"
                        >
                            ×
                        </button>
                        <img src={selectedImage} alt="Zoom réalisation" className="lightbox-img" />
                    </div>
                )}
            </div>
        </section>
    );
}